import { useState, useEffect } from 'react';

// ビューポートの高さと幅を返すカスタムフック
export function useViewportSize() {
  const [size, setSize] = useState({
    viewportHeight: window.innerHeight,
    viewportWidth: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setSize({
        viewportHeight: window.innerHeight,
        viewportWidth: window.innerWidth,
      });
    };

    window.addEventListener('resize', handleResize);
    // コンポーネントのアンマウント時にイベントリスナーを削除
    return () => window.removeEventListener('resize', handleResize);
  }, []); // 空の依存配列を指定して、マウント時とアンマウント時のみ実行

  return size;
}


// WEBPACK FOOTER //
// ./src/utilities/useViewPort.jsx